import { render, staticRenderFns } from "./TippView.vue?vue&type=template&id=28b25de5&scoped=true&"
import script from "./TippView.vue?vue&type=script&lang=js&"
export * from "./TippView.vue?vue&type=script&lang=js&"
import style0 from "./TippView.vue?vue&type=style&index=0&id=28b25de5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b25de5",
  null
  
)

export default component.exports